"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var ColorPickerGridCell_base_1 = require("./ColorPickerGridCell.base");
var ColorPickerGridCell_styles_1 = require("./ColorPickerGridCell.styles");
exports.ColorPickerGridCell = Utilities_1.styled(ColorPickerGridCell_base_1.ColorPickerGridCellBase, ColorPickerGridCell_styles_1.getStyles);
//# sourceMappingURL=ColorPickerGridCell.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/SwatchColorPicker/ColorPickerGridCell.js
// module id = 438
// module chunks = 0